(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "moment"], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory(require("_"), require("moment"));
	else
		root["app"] = root["app"] || {}, root["app"]["components"] = factory(root["_"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__29__) {
return 